// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/attachments.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ParentTypeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/attachments.proto.
 */
export const file_cortado_v1_attachments: GenFile = /*@__PURE__*/
  fileDesc("Chxjb3J0YWRvL3YxL2F0dGFjaG1lbnRzLnByb3RvEgpjb3J0YWRvLnYxItEECgpBdHRhY2htZW50EgoKAmlkGAEgASgJEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCRIvCgtwYXJlbnRfdHlwZRgDIAEoDjIaLmNvcnRhZG8udjEuUGFyZW50VHlwZUVudW0SEQoJcGFyZW50X2lkGAQgASgJEhAKCGZpbGVuYW1lGAUgASgJEhQKDGNvbnRlbnRfdHlwZRgGIAEoCRISCgpzaXplX2J5dGVzGAcgASgDEhIKCm9iamVjdF9rZXkYCCABKAkSFgoJZm9sZGVyX2lkGA0gASgJSACIAQESLgoKY3JlYXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKY3JlYXRlZF9ieRgKIAEoCRIuCgp1cGRhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgp1cGRhdGVkX2J5GAwgASgJEi4KD2NyZWF0ZWRfYnlfdXNlchgUIAEoCzIQLmNvcnRhZG8udjEuVXNlckgBiAEBEi4KD3VwZGF0ZWRfYnlfdXNlchgVIAEoCzIQLmNvcnRhZG8udjEuVXNlckgCiAEBEhgKC3BhcmVudF9uYW1lGBYgASgJSAOIAQESGQoMZG93bmxvYWRfdXJsGBcgASgJSASIAQFCDAoKX2ZvbGRlcl9pZEISChBfY3JlYXRlZF9ieV91c2VyQhIKEF91cGRhdGVkX2J5X3VzZXJCDgoMX3BhcmVudF9uYW1lQg8KDV9kb3dubG9hZF91cmwi4gMKDkF0dGFjaG1lbnRMaXRlEgoKAmlkGAEgASgJEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCRIvCgtwYXJlbnRfdHlwZRgDIAEoDjIaLmNvcnRhZG8udjEuUGFyZW50VHlwZUVudW0SEQoJcGFyZW50X2lkGAQgASgJEhAKCGZpbGVuYW1lGAUgASgJEhQKDGNvbnRlbnRfdHlwZRgGIAEoCRISCgpzaXplX2J5dGVzGAcgASgDEhgKC3BhcmVudF9uYW1lGAggASgJSACIAQESFgoJZm9sZGVyX2lkGAkgASgJSAGIAQESEgoKY3JlYXRlZF9ieRgKIAEoCRIdChVjcmVhdGVkX2J5X2ZpcnN0X25hbWUYCyABKAkSHAoUY3JlYXRlZF9ieV9sYXN0X25hbWUYDCABKAkSLgoKY3JlYXRlZF9hdBgUIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgVIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGQoMZG93bmxvYWRfdXJsGB4gASgJSAKIAQFCDgoMX3BhcmVudF9uYW1lQgwKCl9mb2xkZXJfaWRCDwoNX2Rvd25sb2FkX3VybCKBAgoQQXR0YWNobWVudEZvbGRlchIKCgJpZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSHQoQcGFyZW50X2ZvbGRlcl9pZBgDIAEoCUgAiAEBEgwKBG5hbWUYBCABKAkSLgoKY3JlYXRlZF9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKY3JlYXRlZF9ieRgKIAEoCRIuCgp1cGRhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgp1cGRhdGVkX2J5GAwgASgJQhMKEV9wYXJlbnRfZm9sZGVyX2lkQiZaJGh1Yi1iYWNrZW5kL2dlbi9jb3J0YWRvL3YxO2NvcnRhZG92MWIGcHJvdG8z", [file_google_protobuf_timestamp, file_cortado_v1_settings, file_cortado_v1_users]);

/**
 * Attachment represents a file attached to a parent entity
 *
 * @generated from message cortado.v1.Attachment
 */
export type Attachment = Message<"cortado.v1.Attachment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * @generated from field: string filename = 5;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 7;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string object_key = 8;
   */
  objectKey: string;

  /**
   * @generated from field: optional string folder_id = 13;
   */
  folderId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 12;
   */
  updatedBy: string;

  /**
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: optional string parent_name = 22;
   */
  parentName?: string;

  /**
   * @generated from field: optional string download_url = 23;
   */
  downloadUrl?: string;
};

/**
 * Describes the message cortado.v1.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema: GenMessage<Attachment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_attachments, 0);

/**
 * AttachmentLite is a lightweight attachment representation for list payloads
 *
 * @generated from message cortado.v1.AttachmentLite
 */
export type AttachmentLite = Message<"cortado.v1.AttachmentLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * @generated from field: string filename = 5;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 7;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional string parent_name = 8;
   */
  parentName?: string;

  /**
   * @generated from field: optional string folder_id = 9;
   */
  folderId?: string;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;

  /**
   * @generated from field: string created_by_first_name = 11;
   */
  createdByFirstName: string;

  /**
   * @generated from field: string created_by_last_name = 12;
   */
  createdByLastName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string download_url = 30;
   */
  downloadUrl?: string;
};

/**
 * Describes the message cortado.v1.AttachmentLite.
 * Use `create(AttachmentLiteSchema)` to create a new message.
 */
export const AttachmentLiteSchema: GenMessage<AttachmentLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_attachments, 1);

/**
 * AttachmentFolder represents a folder in an organization's attachment library
 *
 * @generated from message cortado.v1.AttachmentFolder
 */
export type AttachmentFolder = Message<"cortado.v1.AttachmentFolder"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional string parent_folder_id = 3;
   */
  parentFolderId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 12;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.AttachmentFolder.
 * Use `create(AttachmentFolderSchema)` to create a new message.
 */
export const AttachmentFolderSchema: GenMessage<AttachmentFolder> = /*@__PURE__*/
  messageDesc(file_cortado_v1_attachments, 2);

